/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-07-21 15:12:32
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-07-29 14:48:01
 */
import Vue from "vue";
import Vuex from "vuex";
import { getSearchUser } from "@/api/api";
Vue.use(Vuex);
const state = {
  order: [],
  classLiveMsg: [],
  activityCheckVisible: false,
  shNoticeShow: false
};
const mutations = {
  OrderList(state, msg) {
    state.order = msg;
  },
  changeClassMsg(state, res) {
    if (res.message.type == 2) {
      let obj = {
        sourceMsg: res.message.message.sourceMsg,
        id: res.message.message.id,
        from: res.result,
        type: 2
      };
      state.classLiveMsg.push(obj);
    }

    if (res.type == 1) {
      let obj = {
        sourceMsg: res.message,
        id: res.id,
        from: "",
        type: 1
      };
      state.classLiveMsg.push(obj);
    }
  },
  clearMsg(state, res) {
    state.classLiveMsg = res;
  },
  setActivityCheckVisible(state, payload) {
    state.activityCheckVisible = payload;
  },
  shNoticeShow(state,payload){
    state.shNoticeShow = payload
  }
};
const getters = {
  activityCheckVisible: state => state.activityCheckVisible
};
const actions = {
  setGargetOrder({ commit }, order) {
    commit("OrderList", order);
  },
  setChangeMsg({ commit }, formData) {
    if (formData.type == 2) {
      getSearchUser({
        userImAccount: formData.message.from
      }).then(res => {
        if (res.msg == "success") {
          commit("changeClassMsg", {
            message: formData,
            result: res.data.nickName
          });
        }
      });
    } else {
      commit("changeClassMsg", formData);
    }
  }
};
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js